import React, {createContext, useContext, ReactNode} from 'react'

interface GlobalConfigState {
    appPreferences: {
        isAccessibilityBannerEnabled?: boolean | null
        accessibilityScriptPath?: string | null //usableNet script path
        PhoneLogin?: boolean
        isBaiduAnalysisEnabled?: boolean
        baiduSiteVerification?: string
        ACCESSIBILITY_USABLENET_JS?: string
        AdditionalMetaTags?: string
        apikeyv3_recaptcha?: string
        pwaLiveChatScript?: string
        PAYPAL_EXPRESS_Disable_Funds?: Array<string>
        PAYPAL_EXPRESS_Allowed_Currencies?: Array<string>
        PP_API_PaymentAction?: boolean
        PP_API_Button_Location?: Array<string>
        paypal_clientId?: string
        paypal_button_style?: string
        ShippingMethod_NI?: string
        Allowed_Suretax_Dispatch?: boolean
        ApplePay_Enabled?: boolean
        ApplePay_MerchantId?: string
        ApplePay_MerchantName?: string
        ApplePay_MerchantCapabilities?: Array<string>
        ApplePay_SupportedNetworks?: Array<string>
        hostLink?: string
        CountriesWithZeroPrices?: Array<string>
        customNumberContact?: string
        whatsAppEnabledCountries?: string
        Catalog_ManName?: string
        enableSocialShare?: Array<string>
        TencentCaptchaScriptUrl?: string | null
        TencentCaptchaAppID?: string | null
        disableEditorialWidget?: string
        CloudinaryImageTransformationsDPR?: string
        CloudinaryImageTransformationsFormat?: string
        CloudinaryImageTransformationsQuality?: string
        CloudinaryImageTransformations?: string
        CloudinaryVideoTransformationsQuality?: string
        CloudinaryVideoTransformationsBitRate?: string
        CloudinaryVideoTransformations?: string
        CloudinaryVideoFormat?: string
        CloudinaryVideoPosterTransformations?: string
        CloudinaryPageDesignerCNAME?: string
        emailRegexFormValidation?: string
    }
}

const GlobalConfigContext = createContext<GlobalConfigState | undefined>(undefined)

/**
 * @name GlobalConfigProvider
 *
 * @provider
 *
 * @description
 * Provides global configuration states and script path information
 * Tomorrow could be requested to activate only under profiling cookies, mantain inside CookieProvider
 *
 * @param {ReactNode} children
 * @param {string} accessibilityPrefs the path returned by the system preference
 * @param {object} appPrefs all system preference used by app
 *
 * @returns {JSX.Element} - Wrapped children.
 */
export const GlobalConfigProvider = ({children, appPreferences = {}}: {children: ReactNode; appPreferences?: GlobalConfigState['appPreferences']}) => {
    return <GlobalConfigContext.Provider value={{appPreferences}}>{children}</GlobalConfigContext.Provider>
}

/**
 * @name useGlobalConfigState
 *
 * @hook
 *
 * @description
 * Custom hook that provides access to the global configuration state context.
 *
 * This hook must be used within a GlobalConfigProvider.
 *
 * @throws {Error} If the hook is used outside of a GlobalConfigProvider.
 *
 * @returns {GlobalConfigState} The current state from the global configuration context.
 */
export const useGlobalConfigState = (): GlobalConfigState => {
    const context = useContext(GlobalConfigContext)
    if (!context) {
        throw new Error('useGlobalConfigState must be used within a GlobalConfigProvider')
    }
    return context
}
